import * as firebase from 'firebase'

export default {
  state: {
    loadedLocations: [
      {
        locationId: 'tri',
        locationName: 'Location Sample',
        locationStreetAddress: '',
        locationCity: '',
        locationState: '',
        locationZipcode: ''
      }
    ]
  },
  mutations: {
    setLoadedLocations (state, payload) {
      state.loadedLocations = payload
    },
    createLocation (state, payload) {
      state.loadedLocations.push(payload)
    },
    updateLocation (state, payload) {
      const location = state.loadedLocations.find(location => {
        return location.locationId === payload.locationId
      })
      if (payload.locationName) {
        location.locationName = payload.locationName
      }
      if (payload.locationStreetAddress) {
        location.locationStreetAddress = payload.locationStreetAddress
      }
      if (payload.locationCity) {
        location.locationCity = payload.locationCity
      }
      if (payload.locationState) {
        location.locationState = payload.locationState
      }
      if (payload.locationZipcode) {
        location.locationZipcode = payload.locationZipcode
      }
    },
    deleteLocation (state, payload) {
      const location = state.loadedLocations.find(function (location) {
        return location.locationId === payload.locationId
      })
      var todos = state.loadedLocations
      todos.splice(todos.indexOf(location), 1)
    }
  },
  actions: {
    loadLocations ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('locations').once('value')
        .then((data) => {
          const locations = []
          const obj = data.val()
          for (let key in obj) {
            locations.push({
              locationId: key,
              locationName: obj[key].locationName,
              locationStreetAddress: obj[key].locationStreetAddress,
              locationCity: obj[key].locationCity,
              locationState: obj[key].locationState,
              locationZipcode: obj[key].locationZipcode,
              creatorId: obj[key].creatorId
            })
          }
          console.log(locations)
          commit('setLoadedLocations', locations)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createLocation ({commit, getters}, payload) {
      const location = {
        locationName: payload.title,
        locationStreetAddress: payload.locationStreetAddress,
        locationCity: payload.locationCity,
        locationState: payload.locationState,
        locationZipcode: payload.locationZipcode,
        // locationId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'location_on',
        creatorId: getters.user.id
      }
      firebase.database().ref('locations').push(location)
        .then(() => {
          commit('createLocation', {
            ...location
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createLocation', location)
    },
    // May have to create a separate Action for each updated item (i.e. updateLocationLocation, updateLocationDescription, etc)
    updateLocationData ({commit}, payload) {
      commit('setLoading', true)
      console.log(JSON.stringify(payload.locations.locationName))
      const updateObj = {}
      if (payload.locations.locationName) {
        updateObj.locationName = payload.locations.locationName
      }
      if (payload.locations.locationStreetAddress) {
        updateObj.locationStreetAddress = payload.locations.locationStreetAddress
      }
      if (payload.locations.locationCity) {
        updateObj.locationCity = payload.locations.locationCity
      }
      if (payload.locations.locationState) {
        updateObj.locationState = payload.locations.locationState
      }
      if (payload.locations.locationZipcode) {
        updateObj.locationZipcode = payload.locations.locationZipcode
      }
      firebase.database().ref('locations').child(payload.locations.locationId).update(updateObj)
      .then(() => {
        commit('setLoading', false)
        commit('updateLocation', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    },
    deleteLocationData ({commit}, payload) {
      commit('setLoading', true)
      console.log('Payload: ' + JSON.stringify(payload))
      firebase.database().ref('locations').child(payload.locationId).remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteLocation', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedLocations (state) {
      return state.loadedLocations.sort((locationA, locationB) => {
        return locationA.date > locationB.date
      })
    },
    featuredLocations (state, getters) {
      return getters.loadedLocations.slice(0, 5)
    },
    loadedLocation (state) {
      return (someId) => {
        return state.loadedLocations.find((location) => {
          return location.locationId === someId
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/location/index.js